<div class="container-fluid bg-white">
  <header class="row align-items-center">
    <div class="col-xl-3 col-12" [ngClass.sm]="'pt-1'" [ngClass.md]="'pt-1'">
      <img src="../assets/images/logo/nepta.svg" alt="brand-logo" height="28" />
    </div>
    <div class="col-xl-9 col-12 px-xl-0">
      <app-onboarding-header></app-onboarding-header>
    </div>
  </header>

  <div class="row" id="main-container">
    <div class="col-md-9 col-12 offset-md-3 pt-2 position-relative" [formGroup]="formGroup">
      <!--            anagrafica-->
      <div class="row">
        <div class="col-lg-6 col-md-6 col-12">
          <h1 [ngClass.sm]="'mb-0'">{{ "MASTERDATA" | translate }}</h1>
          <small>{{ "INSERT.PERSONAL_INFORMATION" | translate }}</small>
        </div>
        <div class="col-lg-6 col-md-6 col-12 text-lg-right text-md-right text-left">
          <span (click)="showVideo()" [ngbTooltip]="'SHOW_TUTORIAL' | translate" placement="top" class="cursor-pointer text-primary">{{ "DONT_KNOW_HOW_TO_DO" | translate }}</span>
        </div>
      </div>

      <!-----------------------------------------------FORM PERSONAL INFORMATION--------------------------------------------------------------->
      <div class="row my-2 border-bottom pb-2 pr-md-2">
        <div class="col-md-5 form-group media col-12" [ngClass.sm]="'flex-column'" [ngClass.md]="'flex-column'">
          <!--                    avatar-->
          <a href="javascript:void(0);" (click)="file.click()" class="mr-25">
            <img *ngIf="avatarImage" [src]="avatarImage" class="rounded mr-50 cover" alt="profile image" height="150" width="150" />
            <img *ngIf="!avatarImage && !currentUser?.avatar" src="../assets/images/placeholder-avatar.png" class="rounded mr-50" alt="profile image" height="150" width="150" />
          </a>

          <!--                    upload and reset button-->
          <div class="media-body pt-2" [ngClass.xl]="'ml-1'">
            <label class="d-block mb-075" for="account-upload">{{ "PROFILE_PICTURE" | translate }}<sup class="text-danger">*</sup></label>
            <button (click)="file.click()" type="button" class="btn btn-md btn-primary mb-75 mr-75" rippleEffect>{{ "INSERT.UPLOAD_FILE" | translate }}</button>
            <input type="file" #file id="account-upload" hidden accept="image/jpg, image/jpeg, image/png" (change)="handlerChangeFileInput($event, 'avatar')" />
            <p class="font-small-2">{{ "MESSAGES.AVATAR_UPLOAD_INFO" | translate }}</p>
          </div>
          <!--                    / upload and reset button-->
        </div>

        <div class="col-md-7 col-12">
          <div class="row">
            <div class="form-group col-lg-6 col-12">
              <label for="firstname">{{ "FIRSTNAME" | translate }}<sup class="text-danger">*</sup></label>
              <input type="text" id="firstname" class="form-control {{ fieldHasErrors('firstname') ? 'is-invalid' : '' }}" formControlName="firstname" />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_NAME" | translate }}</div>
            </div>
            <div class="form-group col-lg-6 col-12">
              <label for="lastname">{{ "LASTNAME" | translate }}<sup class="text-danger">*</sup></label>
              <input type="text" id="lastname" class="form-control {{ fieldHasErrors('lastname') ? 'is-invalid' : '' }}" formControlName="lastname" />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_LASTNAME" | translate }}</div>
            </div>
            <div class="form-group col-lg-6 col-12">
              <label for="privatePhone">{{ "PRIVATE_PHONE" | translate }}<sup class="text-danger">*</sup></label>
              <input type="tel" id="privatePhone" class="form-control {{ fieldHasErrors('private_phone') ? 'is-invalid' : '' }}" formControlName="private_phone" />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_PRIVATE_PHONE" | translate }}</div>
            </div>
            <div class="form-group col-lg-6 col-12">
              <label for="privateEmail">{{ "PRIVATE_EMAIL" | translate }}<sup class="text-danger">*</sup></label>
              <input type="email" id="privateEmail" class="form-control {{ fieldHasErrors('private_email') ? 'is-invalid' : '' }}" formControlName="private_email" />
              <div class="invalid-feedback">{{ "ERRORS.INSERT_PRIVATE_EMAIL" | translate }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-----------------------------------------------Indirizzo di residenza--------------------------------------------------------------->
      <div class="row border-bottom pb-2 mb-2 pr-md-2">
        <div class="col-12">
          <h3>{{ "RESIDENCE_ADDRESS" | translate }}</h3>
        </div>
        <div class="form-group col-md-8 col-12">
          <label for="residence_address">{{ "ADDRESS" | translate }}<sup class="text-danger">*</sup></label>
          <input type="text" id="residence_address" class="form-control {{ fieldHasErrors('residence_address') ? 'is-invalid' : '' }}" formControlName="residence_address" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
        </div>
        <div class="col-md-4 col-12 form-group" *ngIf="formGroup.value.residence_external">
          <label for="residence_country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            id="residence_country"
            [items]="nationsWithCodes"
            bindLabel="name"
            bindValue="code"
            [clearable]="false"
            formControlName="residence_country"
            [ngClass]="fieldHasErrors('residence_country') ? 'is-invalid' : ''"
          ></ng-select>
        </div>
        <div class="form-group col-md-4 col-12" *ngIf="!formGroup.value.residence_external">
          <label for="residence_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
          <input pattern="[0-9]+" type="text" id="residence_zipcode" class="form-control {{ fieldHasErrors('residence_zipcode') ? 'is-invalid' : '' }}" formControlName="residence_zipcode" />
          <div class="invalid-feedback" *ngIf="formGroup.controls.residence_zipcode.errors?.required">{{ "ERRORS.INSERT_ZIP_CODE" | translate }}</div>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.residence_zipcode?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.residence_zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
        </div>
        <div class="form-group col-md-6 col-12" *ngIf="!formGroup.value.residence_external">
          <label for="residence_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            formControlName="residence_city"
            id="residence_city"
            bindLabel="nice_name"
            bindValue="id"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [items]="_citiesService.list"
            [openOnEnter]="false"
            [virtualScroll]="true"
            (change)="setAutoProvince('residence')"
          >
          </ng-select>
          <div class="invalid-feedback" *ngIf="formGroup.controls.residence_city.errors?.required">{{ "ERRORS.INSERT_CITY" | translate }}</div>
        </div>
        <div class="form-group col-md-6 col-12" *ngIf="!formGroup.value.residence_external">
          <label for="residence_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            formControlName="residence_province"
            id="residence_province"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [items]="provinces_list"
            [openOnEnter]="false"
            [virtualScroll]="true"
          >
          </ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PROVINCE" | translate }}</div>
        </div>
        <div class="form-group col-md-6 col-12 d-flex align-items-center">
          <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
          <div class="custom-control custom-control-primary custom-switch">
            <input type="checkbox" class="custom-control-input" id="customSwitchExternal" formControlName="residence_external" (change)="manageExternalSiteResidence()" />
            <label class="custom-control-label" for="customSwitchExternal"> </label>
          </div>
        </div>
      </div>
      <!-----------------------------------------------Indirizzo di domicilio--------------------------------------------------------------->
      <div class="row border-bottom pb-2 mb-2 pr-md-2">
        <div class="form-group col-md-6 col-12">
          <h3>{{ "ADDRESS_DOMICILE" | translate }}</h3>
        </div>
        <div
          *ngIf="
            (formGroup.value.residence_address && formGroup.value.residence_zipcode && formGroup.value.residence_city && formGroup.value.residence_province) ||
            (formGroup.value.residence_address && formGroup.value.residence_external)
          "
          class="form-group col-md-6 col-12 pr-0 d-flex"
          [ngClass.xl]="'justify-content-end'"
        >
          <small class="mr-1 mt-025">{{ "ADDRESS_SAME_RESIDENCE" | translate }}</small>
          <div class="custom-control custom-control-primary custom-switch">
            <input type="checkbox" [checked]="usedSameAddresses" class="custom-control-input" id="customSwitch10" (click)="copyResidence()" />
            <label class="custom-control-label" for="customSwitch10"> </label>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="form-group col-md-8 col-12">
          <label for="living_address">{{ "ADDRESS" | translate }}<sup class="text-danger">*</sup></label>
          <input type="text" id="living_address" class="form-control {{ fieldHasErrors('living_address') ? 'is-invalid' : '' }}" formControlName="living_address" [readonly]="usedSameAddresses" />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_ADDRESS" | translate }}</div>
        </div>
        <div class="col-md-4 col-12 form-group" *ngIf="formGroup.value.living_external">
          <label for="living_country">{{ "COUNTRY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            id="living_country"
            [items]="nationsWithCodes"
            bindLabel="name"
            bindValue="code"
            [clearable]="false"
            formControlName="living_country"
            [ngClass]="fieldHasErrors('living_country') ? 'is-invalid' : ''"
          ></ng-select>
        </div>
        <div class="form-group col-md-4 col-12" *ngIf="!formGroup.value.living_external">
          <label for="living_zipcode">{{ "ADDRESS_ZIPCODE" | translate }}<sup class="text-danger">*</sup></label>
          <input
            pattern="[0-9]+"
            maxlength="5"
            minLength="5"
            id="living_zipcode"
            class="form-control {{ fieldHasErrors('living_zipcode') ? 'is-invalid' : '' }}"
            formControlName="living_zipcode"
            [readonly]="usedSameAddresses"
          />
          <div class="invalid-feedback">{{ "ERRORS.INSERT_ZIP_CODE" | translate }}</div>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.living_zipcode?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
          <div class="invalid-feedback" *ngIf="formGroup.controls?.living_zipcode?.errors?.maxlength">{{ "MAX" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
        </div>
        <div class="form-group col-md-6 col-12" *ngIf="!formGroup.value.living_external">
          <label for="living_city">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [readonly]="usedSameAddresses"
            id="living_city"
            formControlName="living_city"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [openOnEnter]="false"
            [virtualScroll]="true"
            (change)="setAutoProvince('living')"
          >
            <ng-option *ngFor="let city of _citiesService.list" [value]="city.id">
              {{ city.nice_name }}
            </ng-option>
          </ng-select>
          <div class="invalid-feedback" *ngIf="formGroup.controls.living_city.errors?.required">{{ "ERRORS.INSERT_CITY" | translate }}</div>
        </div>
        <div class="form-group col-md-6 col-12" *ngIf="!formGroup.value.living_external">
          <label for="living_province">{{ "ADDRESS_PROVINCE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select
            [readonly]="usedSameAddresses"
            formControlName="living_province"
            id="living_province"
            bindLabel="name"
            bindValue="id"
            [searchable]="true"
            [closeOnSelect]="true"
            [clearable]="false"
            [items]="provinces_list"
            [openOnEnter]="false"
            [virtualScroll]="true"
          ></ng-select>
          <div class="invalid-feedback">{{ "ERRORS.INSERT_PROVINCE" | translate }}</div>
        </div>
        <div class="form-group col-md-2 col-12 d-flex align-items-center">
          <small class="mr-1">{{ "EXTERNAL_ADDRESS_QUESTION" | translate }}</small>
          <div class="custom-control custom-control-primary custom-switch">
            <input type="checkbox" class="custom-control-input" id="customSwitchExternalLiving" formControlName="living_external" (change)="manageExternalSiteLiving()" />
            <label class="custom-control-label" for="customSwitchExternalLiving"> </label>
          </div>
        </div>
      </div>
      <!-----------------------------------------------Bottone avanti--------------------------------------------------------------->
      <div class="row pr-md-2">
        <div class="col-12 mb-4 d-flex justify-content-end">
          <button type="submit" (click)="save()" class="btn btn-primary">{{ "NEXT" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
